import { MAJOR_DETAIL_ROUTE, MAJOR_MASTER_ROUTE } from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import { Switch } from "react-router-dom";
import MajorMaster from "./MajorMaster/MajorMaster";
import MajorDetail from "./MajorDetail/MajorDetail";

function MajorView() {
  return (
    <Switch>
      <ProtectedRoute
        path={MAJOR_MASTER_ROUTE}
        key={MAJOR_MASTER_ROUTE}
        component={MajorMaster}
        auth={true}
      />
      <ProtectedRoute
        path={MAJOR_DETAIL_ROUTE}
        key={MAJOR_DETAIL_ROUTE}
        component={MajorDetail}
        auth={true}
      />
    </Switch>
  );
}

export { MajorMaster, MajorDetail };
export default MajorView;
